import React from "react";
import { Button, Icon } from "react-onsenui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faPlus, faSync, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const Stage6Content = ({
  claim,
  setUploadType,
  setDocName,
  setCameraModalVis,
  handleDocPreview,
  setPreviewDocModal,
  setFocusedExtraImageID,
  claimedArea,
  setClaimedArea,
  patchClaimArea,
  claimedAreaCFRR,
  setClaimedAreaCFRR,
  patchClaimAreaCFRR,
}) => {
  return (
    <>
      {/* Header Section */}
      <div style={{ padding: "20px", backgroundColor: "#5C7232", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "600" }}>दावा विवरण</h2>
      </div>

      {/* Form 13 Section */}
      <div style={{ borderTop: "1px solid #fff", padding: "20px" }}>
        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>दावा अभिलेख (2.11)</h4>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
          <Button
            modifier="large"
            style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
            onClick={() => {
              if (!Boolean(claim?.courtDocuments[12]?.title === "SDM_SUMMON_RESULT_13")) {
                setUploadType("MAIN_DOC");
                setDocName("SDM_SUMMON_RESULT_13");
                setCameraModalVis(true);
              } else {
                setPreviewDocModal(true);
                handleDocPreview(claim?.courtDocuments[12]?.storageUrl);
              }
            }}
          >
            {!Boolean(claim?.courtDocuments[12]?.title === "SDM_SUMMON_RESULT_13") ? (
              <>
                <Icon icon="md-camera" size={20} />
                {Boolean(
                  claim?.extraImageFormCountForSync &&
                    claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_13"] !== 0
                ) && (
                  <FontAwesomeIcon icon={faSync} size="lg" color="#fff" style={{ marginLeft: "10px" }} />
                )}
              </>
            ) : (
              "फोटो देखें"
            )}
          </Button>

          {Boolean(claim?.courtDocuments[12]?.title === "SDM_SUMMON_RESULT_13") && (
            <Button
              modifier="large"
              style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_13");
                setUploadType("MAIN_DOC");
                setCameraModalVis(true);
              }}
            >
              <FontAwesomeIcon icon={faCamera} size="lg" />
            </Button>
          )}
        </div>

        {claim?.courtDocuments[12]?.extraImages?.map((item, indd) => (
          <div key={`extra-image-${indd}`} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
            <Button
              modifier="large"
              style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                if (!(claim?.courtDocuments.length && claim?.courtDocuments[12]?.title === "SDM_SUMMON_RESULT_13")) {
                  setDocName("SDM_SUMMON_RESULT_13");
                  setCameraModalVis(true);
                } else {
                  setPreviewDocModal(true);
                  handleDocPreview(item?.url);
                }
              }}
            >
              {!Boolean(claim?.courtDocuments[12]?.title === "SDM_SUMMON_RESULT_13") ? (
                <FontAwesomeIcon icon={faCamera} size="lg" />
              ) : (
                "फोटो देखें"
              )}
            </Button>

            {claim?.courtDocuments[12]?.title === "SDM_SUMMON_RESULT_13" && (
              <Button
                modifier="large"
                style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
                onClick={() => {
                  setDocName("SDM_SUMMON_RESULT_13");
                  setCameraModalVis(true);
                  setFocusedExtraImageID(indd + 1);
                  setUploadType("UPDATE_EXTRA_IMAGE");
                }}
              >
                <FontAwesomeIcon icon={faCamera} size="lg" />
              </Button>
            )}
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
          {Boolean(
            claim?.courtDocuments[12]?.title === "SDM_SUMMON_RESULT_13" ||
              Boolean(
                claim?.extraImageFormCountForSync &&
                  claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_13"] !== 0
              )
          ) && (
            <Button
              modifier="large"
              style={{ width: "40%", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_13");
                setCameraModalVis(true);
                setUploadType("NEW_EXTRA_IMAGE");
              }}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" />
            </Button>
          )}
        </div>
      </div>

      {/* Claimed Area Section */}
      <div
        style={{
          justifyContent: "center",
          padding: 20,
          paddingVertical: 20,
          borderBottom: "1px solid #fff",
        }}
      >
       
      </div>
    </>
  );
};

export default Stage6Content;
